
import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';
import { DiagramEntryIcon, StatValue } from '@clients/bff';
import StatValueDisplay from '@/components/statistic/StatValueDisplay.vue';
import TagIcon from '@components/shared/icons/TagIcon.vue';
import LetterIcon from '@components/shared/icons/LetterIcon.vue';
import CircleIcon from '@components/shared/icons/CircleIcon.vue';
import OeamtcIcon, { IconProps } from '@components/new-styleguide/icon/OeamtcIcon.vue';
import StatisticBar from './StatisticBar.vue';

interface EntryView {
  name: string,
  value: StatValue,
  barPercentage?: number,
  icon?: DiagramEntryIcon
};

@Component({
  name: 'StatisticEntryView',
  components: {
    TagIcon,
    LetterIcon,
    CircleIcon,
    StatValueDisplay,
    StatisticBar,
    OeamtcIcon
  }
})
export default class StatisticEntryView extends Vue {
  @Prop()
  private entry: EntryView;

  get tagIcon(): IconProps {
    if (this.entry.icon && this.entry.icon.imageName) {
      const { imageName, fillId, color, characterColor } = this.entry.icon;
      return {
        value: imageName,
        fill: characterColor,
        color,
        fillId
      }
    }

    return undefined;
  }

  get letterIcon(): IconProps {
    if (this.entry.icon && this.entry.icon.character) {
      const { character, color, fillId, characterColor } = this.entry.icon;
      return {
        value: character,
        fill: characterColor,
        color,
        fillId
      }
    }

    return undefined;
  }
}
